export default __webpack_public_path__ + "static/media/wadirum.fa7b1021.jpg";